import Account from "@/helper/AccountHelper.js";
import ConfigManager from "@/config/ConfigManager.js";
import BzbsApi from '@/core/Http/BzbsApi.js';
import HelpchatModel from "./model/HelpchatModel.js"
import { map } from 'rxjs/operators';

export default {
    apiGetHelpchat: function (strUserId, strLastRowkey) {
        const token = Account.getToken();
        let params = {};
        if (strLastRowkey) {
            params.lastRowKey = strLastRowkey;
        }
        const url = ConfigManager.getApiUrl() + `/buzz/f-${strUserId}/list`;
        return BzbsApi.connectBzbsGet(url, token, params).pipe(map((res) => {
            console.log(res);
            let helpchats = [];
            for (let item of res.data) {
                let helpchat = new HelpchatModel (item);
                helpchats.push(helpchat);
            }
            return helpchats;
        }));
    },
    apiSaveComment: function (strMessage, uploadKey, fileUpload) {
        const token = Account.getToken();
        let user = Account.getCacheUser();
        let params = {};
        if (strMessage) {
            params.message = strMessage;
        }
        if (!fileUpload) {
            uploadKey = null;
            fileUpload = null;
        }

        const url = ConfigManager.getApiUrl() + `/buzz/f-${user.userId}/buzz`;
        return BzbsApi.connectBzbsPostUpload(url, token, params, uploadKey, fileUpload).pipe(map((res) => {
            return res;
        }));
    },
    apiGetAllcomment: function (buzzKey, strTop, strLastRowkey) {
        const token = Account.getToken();
        let params = {};
        if (strLastRowkey) {
            params.lastRowKey = strLastRowkey;
        }
        if (strTop) {
            params.$top = strTop;
        }
        const url = ConfigManager.getApiUrl() + `/buzz/${buzzKey}/comments`;
        return BzbsApi.connectBzbsGet(url, token, params).pipe(map((res) => {
            console.log(res);
            let helpchats = [];
            for (let i = res.data.length; i > 0; i--) {
                let helpchat = new HelpchatModel (res.data[i-1]);
                helpchats.push(helpchat);
            }
            return helpchats;
        }));
    },
    apiReplycomment: function (strMessage, uploadKey, fileUpload, buzzkey) {
        const token = Account.getToken();
        let params = {};
        if (strMessage) {
            params.message = strMessage;
        }
        if (!fileUpload) {
            uploadKey = null;
            fileUpload = null;
        }
        const url = ConfigManager.getApiUrl() + `/buzz/${buzzkey}/comments`;
        return BzbsApi.connectBzbsPostUpload(url, token, params, uploadKey, fileUpload).pipe(map((res) => {
            return res;
        }));
    },
}
